import request from '@/utils/request'
import qs from "qs";
export default {
  //用户登陆
  login(data) {
    return request({
      url: '/school/login',
      method: 'post',
      data: data
    })
  },
  //获取用户信息
  userInfo(data) {
    return request({
      url: '/school/user/info',
      method: 'post',
      data: data
    })
  },
  //获取课程下章下拉列表
  // chapterList(data) {
  //   return request({
  //     url: '/school/admin/chapter/list' + '?' + qs.stringify(data, { indices: false }),
  //     method: 'get',
  //   })
  // },
  //获取上传凭证STS
  getUploadStsToken(data) {
    return request({
        url: '/school/common/getUploadStsToken',
        method: 'post',
        data: data
    })
  },
  // 获取文件大小size
  getDownloadUrlSize(data) {
    return request({
      url: '/school/common/getDownloadUrl',
      method: 'post',
      data: data
    })
  },
}